<template>
  <section class="custom-container mb-5">
    <div class="d-flex align-items-center justify-content-between">
      <h3 class="text-color-444 fontsize-heavy m-0">{{ item.title }}</h3>
      <router-link
        class="text-color-white fontsize-mini bg-color-theme2 border-r-30 py-2 px-4 mb-1"
        :to="{
          name: 'product.category',
          params: { category: item.id, slug: slugGenerator(item.slug) },
        }"
      >
        بیشتر
      </router-link>
    </div>

    <div :id="`specialCategory_${item.id}`" class="mt-1 productContainer">
      <div
        class="swiper-container py-3 px-4"
        v-if="!disabledSliders.includes('recommendedProductSlider')">
        <div class="swiper-wrapper">
          <Product
            class="swiper-slide"
            v-for="(product, index) in item.products"
            :key="index + 'index'"
            :product="product"
          />
        </div>
      </div>
      <div class="next-btn-holder d-none d-xl-block">
        <div class="next-btn"><RightChevIcon /></div>
      </div>
      <div class="prev-btn-holder d-none d-xl-block">
        <div class="prev-btn"><RightChevIcon /></div>
      </div>
    </div>
  </section>
</template>
<script>
import Product from "@/parts/Front/components/product/Product";
import Swiper from "swiper/swiper-bundle.min";
import RightChevIcon from "@/parts/Front/components/Icon/RightChevIcon.vue";
let breakpoints = {
  300: {
    slidesPerView: 1.3,
    spaceBetween: 15,
  },
  500: {
    slidesPerView: 2,
    spaceBetween: 10,
  },
  992: {
    slidesPerView: 3.4,
    spaceBetween: 10,
  },
  1200: {
    slidesPerView: 4.2,
    spaceBetween: 20,
  },
};
export default {
  props: {
    item: Object,
  },
  components: {
    Product,
    RightChevIcon,
  },
  data() {
    return {
      id: "specialCategory_",
    };
  },
  mounted() {
    this.id += this.item.id;
    this.initSlider();
  },
  methods: {
    slugGenerator(item) {
      if (item.slug) return item.slug;
      return item.title?.replaceAll(" ", "-");
    },
    initSlider(kill = false) {
      this.initSwiper(this.id, kill, () => {
        if (this.slider) {
          this.slider.destroy();
        }
        this.slider = new Swiper(`#${this.id} .swiper-container`, {
          spaceBetween: 1,
          loop: false,
          navigation: {
            nextEl: `#${this.id} .next-btn`,
            prevEl: `#${this.id} .prev-btn`,
          },
          breakpoints,
        });
        setTimeout(() => {
          this.minHeight = document
            .querySelector(`#${this.id} .swiper-container`)
            .getBoundingClientRect().height;
        }, 1700);
      });
    },
  },
};
</script>
<style>
.productContainer {
  position: relative;
}

.prev-btn {
  position: absolute;
  top: 53%;
  right: 100%;
  transform: translateY(-50%) rotateY(180deg);
  background-color: #4ea854;
  border-radius: 50%;
  padding: 8px;
  cursor: pointer;
}
.next-btn {
  position: absolute;
  top: 50%;
  left: 100%;
  transform: translateY(-50%);
  background-color: #4ea854;
  border-radius: 50%;
  padding: 8px;
  cursor: pointer;
}
</style>
<style>
.productContainer .swiper-container .swiper-wrapper #product {
  box-shadow: 0px 0px 28.919540405273438px 3.908045768737793px #bababa21;
}
</style>
